export const contactsData = {
    email: 'abdalrhmanalkhoja@gmail.com',
    phone: '+201050778883',
    address: 'Egypt, cairo, naser city - 10 ',
    github: 'https://github.com/abdalrahman1990',
    facebook: 'https://www.facebook.com/#',
    linkedIn: 'https://www.linkedin.com/in/abd-alrahman-alkhoja/',
    twitter: 'https://twitter.com/abd',
    medium: 'https://medium.com/@abd',
    stackOverflow: 'https://stackoverflow.com/users/',
    devUsername: "abd7388"
}